<template>
  <div id="id" class="cutehub">
    <Navigation :browse="browse"/>
    <!-- Main Wrapper-->
    <main>
      <div class="wrap">
        <div class="appBg_cutehub" id="appBg1">
          <div class="cutehubMask"></div>
        </div>
        <div class="contentPanel" id="contentPanel">
          <transition name="fade" v-on:enter="enter" v-on:leave="leave" appear>
            <router-view :main="main" :browse="browse"></router-view>
          </transition>
        </div>
      </div>
      <UnsubModal/>
      <div class="backdrop" id="backdrop"></div>
    </main>
  </div>
</template>

<script>
import Vue from "vue";
import VueRouter from "vue-router";
import axios from "axios";
import cutehub from "./router/cutehub";
import cutehubData from "./components/cutehub/cutehub-js/cutehub.js";
import country_list from "./locales/country_list.json";
import Navigation from "./components/cutehub/Navigation.vue";
import UnsubModal from "./components/cutehub/UnsubModal.vue";
import { mapGetters, mapActions } from "vuex";
import gsap, { TimelineLite, Linear, Power4 } from "gsap";
import ScrollMagic from "scrollmagic";
import "scrollmagic/scrollmagic/uncompressed/plugins/animation.gsap";
import "scrollmagic/scrollmagic/uncompressed/plugins/debug.addIndicators";
import AxiosPlugin from "vue-axios-cors";

Vue.use(VueRouter);
Vue.use(AxiosPlugin);

export default {
  name: "cutehub",
  data() {
    return {
      browse: cutehubData.browse,
      main: cutehubData.main,
      id: this.$route.params.token,
      token: localStorage.getItem("logged-in"),
    };
  },
  components: {
    Navigation,
    UnsubModal,
  },
  computed: mapGetters(["lang_cutehub", "country_cutehub", "host_cutehub"]),
  mounted() {
    this.initScrollContent();
    if (this.$route.name == "DetailPage") {
      document.getElementById("contentPanel").classList.add("detail");
    } else {
      if (this.$route.name == "Login" || this.$route.name == "Unsubscription") {
        document.getElementById("contentPanel").classList.add("login");
      } else {
        document.getElementById("contentPanel").classList.remove("login");
      }
      document.getElementById("contentPanel").classList.remove("detail");
    }
  },
  created() {
    this.getDomain_cutehub(this.host_cutehub);
    this.fetchToken_cutehub(this.id);

    if (window.location.pathname === "/") {
      cutehub.push({ name: "Main" }).catch((err) => {});
    }

    let lang = this.lang_cutehub;
    let country_code = this.country_cutehub;

    if (this.lang_cutehub != "null" && this.lang_cutehub != null) {
      if (this.lang_cutehub == "arabic") {
        localStorage.setItem("lang_cutehub", this.lang_cutehub);
        this.$i18n.locale = this.lang_cutehub;
        document.getElementsByTagName("html")[0].classList.add("ar_layout");
        this.fetchLocale_cutehub(this.lang_cutehub);
      } else {
        localStorage.setItem("lang_cutehub", this.lang_cutehub);
        this.$i18n.locale = this.lang_cutehub;
        document.getElementsByTagName("html")[0].classList.remove("ar_layout");
        this.fetchLocale_cutehub(this.lang_cutehub);
      }
    } else {
      let country_ls = Object.keys(country_list);

      if (country_ls.includes(country_code)) {
        let language = country_list[country_code].language;

        if(localStorage.getItem('userToken_cutehub') == 'chub80'){
          localStorage.setItem("lang_cutehub", 'english');
          this.$i18n.locale = 'english';
          this.fetchLocale_cutehub('english');
        }else{
          localStorage.setItem("lang_cutehub", language);
          this.$i18n.locale = language;
          this.fetchLocale_cutehub(language);
        }

        if (language != "arabic") {
          document
            .getElementsByTagName("html")[0]
            .classList.remove("ar_layout");
        } else {
          document.getElementsByTagName("html")[0].classList.add("ar_layout");
        }
      } else {
        localStorage.setItem("lang_cutehub", "english");
        this.$i18n.locale = "english";
        document.getElementsByTagName("html")[0].classList.remove("ar_layout");
        this.fetchLocale_cutehub("english");
      }
    }
  },

  methods: {
    ...mapActions([
      "fetchLocale_cutehub",
      "fetchToken_cutehub",
      "getDomain_cutehub",
    ]),
    initScrollContent() {
      let contentTitle = document.querySelector("#contentTitle");
      let contentPanel = document.querySelector("#contentPanel");

      let scrollCtrl = new ScrollMagic.Controller({});
      // build tween
      let scrollHeaderTween = gsap.to(contentTitle, 0.5, {
        opacity: 0,
        ease: Linear.easeNone,
      });
      let scrollHeaderScene = new ScrollMagic.Scene({
        triggerElement: ".main_wrap",
        triggerHook: 0.5,
        duration: 300,
      })
        .setTween(scrollHeaderTween)
        // .addIndicators({ name: "1 (duration: 300)" })
        .addTo(scrollCtrl);
    },
    enter(el, done) {
      this.$nextTick(() => {
        gsap.fromTo(
          el,
          1,
          {
            autoAlpha: 0,
            y: 200,
          },
          {
            autoAlpha: 1,
            y: 0,
            transformOrigin: "50% 50%",
            ease: Power4.easeOut,
            delay: 1,
            onComplete: done,
          }
        );
      });
    },
    leave(el, done) {
      this.$nextTick(() => {
        gsap.to(el, 1, {
          autoAlpha: 0,
          ease: Power4.easeOut,
          onComplete: done,
        });
      });
    },
  },
  watch: {
    $route(to, from) {
      const toDepth = to.path.split("/");
      const fromDepth = from.path.split("/");
      //set content panel height of detail  page

      if (this.$route.name == "DetailPage") {
        document.getElementById("contentPanel").classList.add("detail");
      } else {
        if (
          this.$route.name == "Login" ||
          this.$route.name == "Unsubscription"
        ) {
          document.getElementById("contentPanel").classList.add("login");
        } else {
          document.getElementById("contentPanel").classList.remove("login");
        }
        document.getElementById("contentPanel").classList.remove("detail");
        this.$nextTick(() => {
          this.initScrollContent();
        });
      }

      if (from.name == "DetailPage" && to.name == "DetailPage") {
        location.reload();
      }
    },
  },
};
</script>

<style lang="scss">
@import url("./assets/cutehub/styles/app.scss");
// .fade-enter-active,
// .fade-leave-active {
//   transition-property: opacity;
//   transition-duration: 0.25s;
// }

// .fade-enter-active {
//   transition-delay: 0.25s;
// }

// .fade-enter,
// .fade-leave-active {
//   opacity: 0;
// }
body #contentPanel {
  color: #000;
}
.cutehub {
  .policy_wrap {
    background: #fff;
    border-radius: 38px 38px 0px 0px;
    padding: 25px 15px;
    min-height: 780px;
  }
  .mobiBtn,
  .playBtn {
    background: #ed215e;
  }
}
.appBg_cutehub {
  //  background-image: url(/static/img/app-wallpaper.4ce60dd.jpg);
  height: 100%;
  position: fixed;
  width: 100%;
  background: url(./assets/cutehub/imgs/app-wallpaper.jpg) center center repeat;
  background-color: #210e3d;
  background-size: cover;
  z-index: 3;
}
.cutehubMask {
  background-color: rgba(0, 0, 0, 0.85);
  width: 100%;
  height: 100%;
}
.contentPanel {
  position: relative;
  z-index: 4;
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding-top: 520px;
  h3 {
    color: #000;
  }
}
.contentPanel.login {
  position: relative;
  z-index: 4;
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding-top: 200px;
}
.contentPanel.detail {
  padding-top: 80px;
  padding-bottom: 30px;
}
.main_wrap {
  background: #fff;
  border-radius: 38px 38px 0px 0px;
  padding: 25px 15px;
  min-height: 580px;
}

/*##### Typography Styles#####*/
.icon {
  &::before {
    font-size: 21px !important;
  }
}
.mobiTitle {
  margin: 0;
  line-height: 1.1;
  text-transform: capitalize;
  word-break: break-word;
  color: #000;
  .mobiIcon {
    width: 32px;
    display: inline-block;
    vertical-align: middle;
  }
}
.mobiTitle > span {
  vertical-align: middle;
  display: inline-block;
}
.mobiTitle.content {
  padding: 25px 30px;
  text-transform: uppercase;
}
.mobiTitle.white {
  color: #fff;
}
.mobiTitle.lg {
  font-size: 3rem;
}
.mobiTitle.md {
  font-size: 1.4rem;
  font-weight: 600;
}
.mobiTitle.sm {
  font-size: 1.1rem;
}
.mobitxt {
  font-size: 1rem;
  line-height: 1.2;
  font-weight: 300;
}
.mobilabel {
  font-size: 0.9rem;
  color: grey;
  font-weight: 500;
  margin: 8px 0;
}
/*##### Layout Styles#####*/
.mobiSection {
  color: #000;
}
.mobiSection__header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.mobiSection__header {
  padding: 25px 50px;
}
.mobiSection__content {
  padding: 25px 50px;
}
.mobiSection__content {
  .col {
    margin-bottom: 20px;
  }
}
/*##### form Styles#####*/
.inputWrap {
  margin: 25px 0px;
}
.btnContainer {
  text-align: center;
}

.btnContainer.left {
  text-align: left;
}
.btnContainer.inline {
  display: flex;
}
.mobiBtn {
  text-decoration: none;
  display: inline-block;
  padding: 15px 0;
  border-radius: 35px;
  -webkit-box-shadow: none;
  box-shadow: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  width: 100%;
  border: 0px;
  max-width: 320px;
  background: #2ec425;
  color: #fff;
  font-size: 1.6rem;
  font-weight: 600;
  cursor: pointer;
  &:hover {
    text-decoration: none;
    color: #fff;
  }
}
.mobiBtn.sm {
  max-width: 150px;
  font-size: 1rem;
}
.browse_link {
  font-size: 0.9rem;
  font-weight: 500;
  background: transparent;
  width: auto;
  cursor: pointer;
  display: block;
  color: #000;
  &:hover {
    text-decoration: none;
    color: #000;
  }
}
.translationBtns {
  .mobiBtn {
    color: #000;
    background-color: #e6e6e6;
    padding: 4px;
    margin-right: 8px;
    border-radius: 0px;
    img {
      width: 21px;
      margin-right: 5px;
    }
  }
}

.mobiForm {
  text-align: left;
  max-width: 580px;
  margin: 0 auto;
  .mobiForElm {
    margin: 25px 0px;
  }
}
.mobiForElm {
  max-width: 320px;
  width: 100%;
  margin: 15px auto;
  label {
    font-weight: 500;
    font-size: 1rem;
  }
  input,
  textarea,
  select {
    appearance: none;
    outline: none;
    padding: 15px;
    width: 100%;
    border-radius: 25px;
    font-size: 1.2rem;
    font-weight: 500;
    background: #efefef;
    border: 0;
    margin: 0px;
    // box-shadow: 0px 0px 3px 1px rgba(0, 0, 0, 0.33);
  }
  textarea {
    border-radius: 8px;
  }
  button {
    width: 100%;
    border-radius: 25px;
    padding: 15px;
    font-size: 1.3rem !important;
  }
}
.mobiForElm__wrap {
  position: relative;
}
.mobiForElm.lg {
  max-width: 580px;
}
.arrow__upper {
  position: absolute;
  right: 24px;
  top: 50%;
  -webkit-transform: translateY(-50%);
  -ms-transform: translateY(-50%);
  transform: translateY(-50%);
  pointer-events: none;
}

.arrow__upper:before,
.arrow__upper:after {
  content: "";
  position: absolute;
  display: block;
  right: -9px;
  width: 12px;
  height: 4px;
  background: #babebf;
  -moz-border-radius: 2px;
  -webkit-border-radius: 2px;
  border-radius: 2px;
}

.arrow__upper:before,
.arrow__upper:after {
  top: 0px;
  -moz-transform: rotate(-45deg);
  -ms-transform: rotate(-45deg);
  -webkit-transform: rotate(-45deg);
  transform: rotate(-45deg);
}

.arrow__upper:after {
  right: inherit;
  left: -9px;
  -moz-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  -webkit-transform: rotate(45deg);
  transform: rotate(45deg);
}
/*##### Shared Styles#####*/
.playBtn {
  position: absolute;
  z-index: 10;
  top: 50%;
  left: 50%;
  -webkit-transform: translateX(-50%) translateY(-50%);
  transform: translateX(-50%) translateY(-50%);
  -webkit-box-sizing: content-box;
  box-sizing: content-box;
  display: block;
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background: #fa183d;
  line-height: 65px;
  text-align: center;
  span {
    display: inline-block;
    position: relative;
    z-index: 3;
    width: 0;
    height: 0;
    margin-left: 8px;
    border-left: 18px solid #fff;
    border-top: 14px solid transparent;
    border-bottom: 14px solid transparent;
  }
}
.backdrop {
  position: fixed;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  background: rgba(0, 0, 0, 0.4);
  visibility: hidden;
  opacity: 0;
  z-index: 98;
}
.mobiApp {
  display: block;
  color: #000;
  &:hover {
    text-decoration: none;
    color: #000;
  }
}
.mobiApp__thumb {
  width: 130px;
  height: 130px;
  margin: 0 auto;
  border-radius: 25px;
  overflow: hidden;
  position: relative;
  img {
    width: 100%;
  }
}
.mobibadge {
  position: absolute;
  right: 28px;
  top: 100px;
  width: 38px;
  z-index: 1;
  img {
    width: 100%;
    height: auto;
  }
}
.mobiApp__info {
  padding: 12px 0px;
  width: 130px;
  margin: 0 auto;
  display: flex;
  height: 89px;
  flex-direction: column;
  justify-content: space-between;
  p {
    margin: 0 0 8px;
    font-size: 1rem;
  }
}
.mobiApp__info {
  margin-bottom: 15px;
}
.mobiVideo {
  position: relative;
  height: 180px;
  border-radius: 12px;
  overflow: hidden;
  display: block;
  &:hover .mobiVideo__thumb {
    transform: scale(1);
  }
}
.mobiVideo--mrgn {
  margin-bottom: 1rem;
}
.mobiVideo__thumb {
  width: 100%;
  position: relative;
  transition: 3000ms cubic-bezier(0.22, 0.61, 0.36, 1);
  transform: scale(1.1);
  &::before {
    content: "";
    position: absolute;
    width: 100%;
    height: 100%;
    background: rgb(0, 0, 0);
    background: linear-gradient(
      0deg,
      rgba(0, 0, 0, 0.55) 5%,
      rgba(255, 255, 255, 0) 50%
    );
  }
  img {
    width: 100%;
    height: 180px;
    object-fit: cover;
    object-position: center;
  }
}
.mobiVideo__info {
  position: absolute;
  width: 100%;
  bottom: 0;
  left: 0;
  padding: 15px;
  .mobiTitle,
  p {
    color: #fff;
  }
  .mobiTitle {
    margin-bottom: 8px;
  }
}
.cutehub {
  .spinner {
    animation: rotate 2s linear infinite;
    z-index: 2;
    position: relative;
    top: 50%;
    left: 50%;
    margin: -25px 0 0 -25px;
    width: 50px;
    height: 50px;

    & .path {
      stroke: #ed215e;
      stroke-linecap: round;
      animation: dash 1.5s ease-in-out infinite;
    }
  }
}

@keyframes rotate {
  100% {
    transform: rotate(360deg);
  }
}

@keyframes dash {
  0% {
    stroke-dasharray: 1, 150;
    stroke-dashoffset: 0;
  }
  50% {
    stroke-dasharray: 90, 150;
    stroke-dashoffset: -35;
  }
  100% {
    stroke-dasharray: 90, 150;
    stroke-dashoffset: -124;
  }
}
/*##### Arabic layout Styles#####*/
.ar_layout {
  body,
  .thumbCol__label {
    direction: rtl;
  }
  .mobiBtnContainer {
    text-align: right;
  }
  .mobitxt,
  .mobiTitle {
    direction: rtl;
    text-align: right;
  }
  .mobiApp__info {
    text-align: right;
  }
  .mobiTitle.content,
  .contentDetail__info ul,
  .contentDetail__info ul li {
    text-align: right;
  }
  .vue-star-rating-inline {
    display: flex !important;
  }
  .mobiSearch__wrap label {
    left: 0;
    right: auto !important;
  }
  .navLinks .navLinks__item a {
    text-align: right;
    .icon::before {
      padding-right: 0px;
      padding-left: 8px;
    }
  }
  .translationBtns .mobiBtn {
    margin-right: 0px;
    margin-left: 8px;
  }
}
/*##### Responsive layout Styles#####*/
@media only screen and (max-width: 991px) {
  .appBg_cutehub {
    background-size: 100%;
  }
  .contentPanel {
    padding-top: calc(100% - 20vh);
  }
  .contentPanel.detail {
    padding: 80px 15px 25px;
  }
  .mobiSection__header,
  .mobiSection__content {
    padding: 25px 0px;
  }
  .mobislider {
    li {
      width: 35% !important;
    }
  }
}
@media only screen and (max-width: 589px) {
  .mobiApp__thumb {
    width: 110px;
    height: 110px;
    margin: 0 auto;
  }
  .mobiApp__info {
    width: 100%;
    text-align: center;
    margin: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/Cutehub.vue